$bog_theme_toggle $mol_pop
	theme_auto $bog_theme_auto
	showed?val false
	align \bottom_right
	Anchor $mol_button_minor
		sub /
			<= Icon $mol_view
		hint <= anchor_hint \Переключить тему
		click?event <=> clicked?event null
		event *
			^
			pointerdown?event <=> press_start?event null
			pointermove?event <=> press_move?event null
			pointerup?event <=> press_end?event null
			pointercancel?event <=> press_cancel?event null
			lostpointercapture?event <=> press_lost?event null
	Icon_light $mol_icon_white_balance_sunny
	Icon_dark $mol_icon_weather_night
	Icon_system $mol_icon_monitor
	bubble_content /
		<= Backdrop $mol_view
			event *
				click?event <=> backdrop_click?event null
		<= Picker $bog_theme_picker
			theme_auto <= theme_auto
			close? <=> picker_close? null
